import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { MinExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/MinExpression";

export class MinExpressionEditor extends ExpressionRuleEditor<MinExpression> {
    render() {
        return (
            <ExpressionPiece>
                min
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
